import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'
import './style.css'
import '@assets/fonts/S_CoreDream/s-coredream.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.mount('#app')

// PWA 서비스워커 등록 (자동 업데이트)
import { registerSW } from 'virtual:pwa-register'
registerSW({ immediate: true })

// Service Worker 메시지 핸들러 - 현재 Vue Router URL 응답
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'GET_CURRENT_URL') {
      // Vue Router의 현재 전체 경로 (path + query + hash)
      const currentUrl = router.currentRoute.value.fullPath
      // MessagePort를 통해 응답
      if (event.ports && event.ports[0]) {
        event.ports[0].postMessage({ currentUrl })
      }
    }
  })
}
